import { History } from 'history';
import * as React from 'react';
import { Button, Header, Popup, Segment } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';

interface Props {
    readonly idApoderado: string;
    readonly historial: History;
}

interface State {
    readonly anulando: boolean;
}

class MasOpciones extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        anulando: false,
    };

    public render() {
        return (
            <div>
                <Segment color='red' clearing>
                    <Header as='h3'>Anular todo el proceso de matrícula</Header>

                    <Popup
                        trigger={
                            <Button
                                floated='right'
                                content='Anular proceso'
                                color='red'
                                loading={this.state.anulando}
                            />
                        }
                        on='click'
                        closeOnEscape
                        hideOnScroll
                        hoverable
                    >
                        <Popup.Header content='Anular el proceso' />
                        <Popup.Content>
                            <p>
                                ¿Está seguro que desea anular este proceso? Esta opción se puede
                                deshacer más adelante en la lista de procesos nulos.
                            </p>

                            <Button content='Sí, anular' color='red' onClick={this.anularProceso} />
                        </Popup.Content>
                    </Popup>

                    <p>
                        Esto marcará todo el proceso de matrícula como nulo y ya no aparecerá en la
                        lista de planes de pagos, lista de deudores o de alumnos restringidos.
                    </p>
                </Segment>
            </div>
        );
    }

    private readonly anularProceso = () => {
        const { idApoderado, historial } = this.props;

        clienteApi
            .ejecutar('anularProcesoDeMatricula', { idApoderado })
            .then(() => {
                this.setState({ anulando: false });
                historial.push('/cobranzas/nulos');
            })
            .catch(error => {
                this.setState({ anulando: false });
                this.context.mostrarModalError(error);
            });
    };
}

export default MasOpciones;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/MasOpciones.tsx